import { useDispatch, useSelector } from "react-redux";
import { closeModal, ModalState } from "app/slices/modalSlice";

import { Modals } from "interfaces/enums";

import ViewBankAccountModal from "./ViewBankAccountModal/ViewBankAccountModal";

import SendKyb from "./SendKyb/SendKyb";
import CreateLeadModal from "./CreateLead/CreateLeadModal";
import CreateTazaEntityModal from "./CreateTazaEntity/CreateTazaEntityModal";
import CreateWebhook from "./CreateWebhook/CreateWebhookModal";
import CreateApiKey from "./CreateApiKey/CreateApiKeyModal";
import AcceptTermsModal from "./AcceptTermsModal";
import { IDestinationBankAccountAll } from "interfaces";
import { IRouterOrder, RFIApproval, RFIEntities } from "interfaces/router";
import AcceptGeoLocation from "./AcceptGeoLocation";
import RequestInfoModal from "./RequestInfoModal/RequestInfoModal";
import ApproveRFIModal from "./ApproveRFIModal";
import { EditOrderModal } from "@/pages/ordersCcyConversion/components/EditOrderModal";
import { OrderTimelineModal } from "@/pages/ordersCcyConversion/components/OrderTimelineModal";
import UploadDocumentModal from "@/pages/destinationBankAccountsCcyConversion/Router/components/UploadDocumentModal";
import { Dialog } from "../ui/dialog";

export const ModalsPage = () => {
  const { modalName, data } = useSelector<any, ModalState>(
    (state) => state?.modal,
  );
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <Dialog onOpenChange={handleClose} open={modalName !== Modals.NoModal}>
      {
        {
          [Modals.NoModal]: <></>,
          [Modals.SendKyb]: <SendKyb />,
          [Modals.RequestInfoModal]: (
            <RequestInfoModal data={data as RFIEntities} />
          ),
          [Modals.ApproveRFIModal]: (
            <ApproveRFIModal data={data as RFIApproval} />
          ),
          [Modals.CreateWebhook]: <CreateWebhook />,
          [Modals.CreateApiKey]: <CreateApiKey />,
          [Modals.AcceptTerms]: <AcceptTermsModal />,
          [Modals.EditOrderModal]: (
            <EditOrderModal data={data as IRouterOrder} />
          ),
          [Modals.OrderTimelineModal]: (
            <OrderTimelineModal data={data as IRouterOrder} />
          ),
          [Modals.AcceptGeoLocation]: (
            <AcceptGeoLocation
              data={data as { error: string; loading: boolean }}
            />
          ),
          [Modals.ViewBankAccountModal]: (
            <ViewBankAccountModal data={data as IDestinationBankAccountAll} />
          ),
          [Modals.UploadDocumentModal]: (
            <UploadDocumentModal
              data={data as { destination_account_id: string }}
            />
          ),
          [Modals.CreateLead]: <CreateLeadModal />,
          [Modals.CreateTazaEntity]: (
            <CreateTazaEntityModal
              data={data as { user_id: string; alias?: string }}
            />
          ),
        }[modalName]
      }
    </Dialog>
  );
};

export default ModalsPage;
